import React from 'react';
import { motion } from 'framer-motion';
import { Measurement } from '../types';

interface MeasurementDisplayProps {
  measurement: Measurement;
  showHint: boolean;
  onToggleHint: () => void;
}

export const MeasurementDisplay: React.FC<MeasurementDisplayProps> = ({
  measurement,
  showHint,
  onToggleHint
}) => {
  return (
    <div className="bg-white/20 rounded-2xl p-8 text-center">
      <motion.h2 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold mb-6"
      >
        {measurement.question}
      </motion.h2>
      
      {measurement.type === 'area' && (
        <div className="relative w-64 h-64 mx-auto mb-8 border-4 border-white/50">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl">
            Area Challenge
          </div>
        </div>
      )}

      {measurement.type === 'volume' && (
        <div className="relative w-64 h-64 mx-auto mb-8">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="w-full h-full border-4 border-white/50 transform preserve-3d perspective-1000"
            style={{ transform: 'rotateX(60deg) rotateZ(45deg)' }}
          >
            <div className="absolute inset-0 flex items-center justify-center text-xl">
              Volume Challenge
            </div>
          </motion.div>
        </div>
      )}

      <button
        onClick={onToggleHint}
        className="bg-white/10 px-6 py-2 rounded-full hover:bg-white/20 transition-colors"
      >
        {showHint ? 'Hide Hint' : 'Show Hint'}
      </button>

      {showHint && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-4 text-lg"
        >
          Hint: {measurement.hint}
        </motion.p>
      )}
    </div>
  );
};